import { render } from "./ProgramsView.vue?vue&type=template&id=382000af&scoped=true"
import script from "./ProgramsView.vue?vue&type=script&lang=js"
export * from "./ProgramsView.vue?vue&type=script&lang=js"

import "./ProgramsView.vue?vue&type=style&index=0&id=382000af&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382000af"]])

export default __exports__